import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["edsContext"];
import React from 'react';
import { withEDSContext } from '../EDSContext/EDSContext';

var withPlatform = function withPlatform() {
  return function (WebComponent, MobileComponent) {
    var Wrap = /*#__PURE__*/React.forwardRef(function (props, ref) {
      var edsContext = props.edsContext,
          rest = _objectWithoutPropertiesLoose(props, _excluded);

      return /*#__PURE__*/React.createElement(React.Fragment, null, edsContext.platform === 'mobile' && /*#__PURE__*/React.createElement(MobileComponent, rest), (!edsContext.platform || edsContext.platform === 'web') && /*#__PURE__*/React.createElement(WebComponent, rest));
    });
    return withEDSContext(Wrap);
  };
};

export default withPlatform;